import { Card, CardBody, Col, Row } from 'reactstrap'
import { MultipleBars } from '../../../../Utils/Constants'
import { multipleDta, multipleList } from '../../../../Data/Ui-Kits/Progress/Progress'
import { ProgressBar } from '../../../../AbstractElements'
import CardHeaderCommon from '../../../../Utils/CommonComponents/CardHeaderCommon'

const MultipleBarsCart = () => {
  return (
    <Col xl="6">
      <Card>
        <CardHeaderCommon title={MultipleBars} span={multipleDta} />
        <CardBody className="progress-showcase">
          <Row>
            <Col>
              <ProgressBar multi>
                <ProgressBar color="primary" bar value="30" />
                <ProgressBar color="secondary" bar value="20" />
                <ProgressBar color="success" bar value="15" />
              </ProgressBar>
              <ProgressBar multi>
                {multipleList.map(({ color, value }, index) => (
                  <ProgressBar color={color} bar value={value} key={index} style={{ width: "10%" }} />
                ))}
              </ProgressBar>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  )
}

export default MultipleBarsCart